import { CropDataType } from "../../ts/types";

export const InitialCropData: CropDataType = {
  name: "",
};
